/* eslint-disable react-hooks/exhaustive-deps */
import { loginWithUsernamePassword } from '@client/new/api/auth.api';
import { useUser } from '@client/new/hooks/use-user';
import { navigate, PATHS } from '@client/routes';
import { useCallback } from 'react';
import { useForm } from 'react-hook-form';
import { toast } from 'react-hot-toast';
import { Link } from '@client/router/compat';
import { AuthLayout } from '../../auth.layout';
import { takePostLoginPath } from '../../model/post-login-path.model';
import { clsx } from 'clsx';
import * as styles from './login-with-password.page.css';

export const CreatorLoginWithPasswordPage = () => {
  const { login } = useUser();
  const { register, handleSubmit } = useForm();

  const onSubmit = useCallback(async (values) => {
    loginWithUsernamePassword(values.username, values.password)
      .then(({ user }) => {
        login(user);
        navigate(takePostLoginPath() ?? PATHS.HOME);
      })
      .catch((error) => {
        console.log(error);
        toast.error('Invalid credentials');
      });
  }, []);

  return (
    <AuthLayout title="Sign in to Playbook">
      <div className="w-full flex flex-col text-center">
        <form
          className="mt-8 w-full flex flex-col gap-3"
          onSubmit={handleSubmit(onSubmit)}
        >
          <input
            aria-label="Username"
            type="text"
            required
            className={clsx(styles.field, 'w-full text-center')}
            placeholder="Type your username"
            {...register('username', { required: true })}
          />
          <input
            aria-label="Password"
            type="password"
            required
            className={clsx(styles.field, 'w-full text-center')}
            placeholder="Type your password"
            {...register('password', { required: true })}
          />
          <button
            type="submit"
            className={clsx(styles.submitButton, 'w-full mt-5')}
          >
            Sign in
          </button>
        </form>
        <p className={clsx(styles.paragraph, 'mt-5')}>
          <span className="font-bold">{"Don't have an account?"}</span>{' '}
          <Link className={styles.link} to={'/sign-up'}>
            Sign up
          </Link>
        </p>
      </div>
      <p className={styles.paragraph}>
        <Link className={styles.link} to={'/login'}>
          Sign in with magic code
        </Link>
      </p>
    </AuthLayout>
  );
};
